<template>
    <l-layout :layout="['xs12']" >
          <l-data-table
            ref="smsTemplateList"
          title-text="短信模板管理"
          :headers="header"
          :get-data-func="getSmsTemplateList"
          :filter-items="filterItems"
          search-text="搜索模板"
          v-model="selected"
          @click:row="getDetails($event.item,'readonly')"
          clickable
          selectable>
            <template slot="title-action">
              <v-menu left>
                <v-btn
                  icon
                  slot="activator"
                >
                  <v-icon>$vuetify.icons.more</v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile
                    @click="deleteTemplate(selected)"
                  >
                    <v-list-tile-title class="pr-1">
                      <v-flex layout align-center>
                        <v-icon class="pr-3">$vuetify.icons.delete</v-icon>
                        <span>批量删除</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile>
                  <!--<v-list-tile @click="">-->
                  <!--<v-list-tile-title>导出</v-list-tile-title>-->
                  <!--</v-list-tile>-->
                </v-list>
              </v-menu>
            </template>
            <template slot="row-action" slot-scope="{item}">
              <td @click.stop class="px-0 mx-0 text-xs-center">
              <v-btn icon @click="deleteTemplate(item)">
                <v-icon>$vuetify.icons.delete</v-icon>
              </v-btn>
              </td>
            </template>
          </l-data-table>
      <l-fixed-btn
        @click="addSmsTemplate"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </l-layout>
</template>
<script>
import {time} from '../../../ladmin/utils/time'
import LDataTable from '../../../ladmin/components/LDataTable/LDataTable'
import LFixedBtn from '../../../ladmin/components/LFixedBtn/LFixedBtn'
var cloneObj = function (obj) {
  var newObj = {}
  if (obj instanceof Array) {
    newObj = []
  }
  for (var key in obj) {
    var val = obj[key]
    // newObj[key] = typeof val === 'object' ? arguments.callee(val) : val; //arguments.callee 在哪一个函数中运行，它就代表哪个函数, 一般用在匿名函数中。
    newObj[key] = typeof val === 'object' ? cloneObj(val) : val
  }
  return newObj
}
export default {
  name: 'smsTemplateList',
  components: {LFixedBtn, LDataTable},
  data () {
    return {
      selected: [],
      header: [
        {text: '模板标题', align: 'left', sortable: false, value: 'name'},
        {text: '所属模块', align: 'left', sortable: false, value: 'module'},
        {text: '模板类型', align: 'left', sortable: false, value: 'type'},
        {text: '操作人', align: 'left', sortable: false, value: 'editor'},
        {text: '添加时间', align: 'left', sortable: true, value: 'creationTime', f: (v) => time.stringify(v), placeholder: 'N/A'},
        {text: '', value: '', align: 'left', sortable: false}
      ],
      filterItems: [
        {
          prependIcon: 'mdi-bookmark',
          key: 'moduleType',
          value: '',
          label: '模板类型',
          type: 'select',
          items: [
            {text: '短信模板', value: 'sms'},
          ],
          itemValue: 'value',
          itemText: 'text',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: 'mdi-view-grid',
          key: 'module',
          value: '',
          label: '所属模块',
          type: 'select',
          items: [],
          itemValue: 'value',
          itemText: 'text',
          layout: ['xs12', 'sm4'],
        },
        {
          key: 'creationTime',
          value: {},
          label: '添加日期',
          type: 'duration',
          layout: ['xs12', 'sm4'],
          f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
          range: true
        },
      ],
    }
  },
  computed: {
    moduleList () {
      return this.$store.state.messageManagement.moduleList
    }
  },
  async created () {
    this.getModuleList()
  },
  methods: {
    async getModuleList () {
      let res = await this.$store.dispatch('messageManagement/getModuleList')
      let items = []
      for (var i in res.data.data) {
        let obj = {
          value: i,
          text: res.data.data[i]
        }
        items.push(obj)
      }
      this.$store.commit('messageManagement/setModuleList', items)
      this.filterItems[1].items = this.moduleList
    },
    async getSmsTemplateList ({pagination, sortStack, filterItems = [], search}) {
      let searchParam = {
        'searchParam': {
          'type': {
            'keyword': 'sms',
            'order': 'ASC'
          },
          'module': {
            'keyword': filterItems[1].value,
            'order': 'ASC'
          },
          'name': {
            'keyword': search,
            'order': 'ASC'
          },
        }
      }
      let res = await this.$store.dispatch('messageManagement/getTemplateList', {pagination: pagination, searchParam: searchParam})
      if (res.data.status === 1) {
        return {items: res.data.data.content, amount: res.data.data.totalElements}
      }
      else {
        this.$L.alert('error', {message: '查询失败，原因:' + res.data.msg})
      }
    },
    async deleteTemplate (item) {
      // console.log(item)
      let ids = []
      if (item instanceof Array) {
        // console.log(item)
        for (let n in item) {
          ids.push(item[n].id)
        }
      }
      else {
        ids.push(item.id)
      }
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要删除该配置？'})
      if (res) {
        try {
          let res = await this.$store.dispatch('messageManagement/deleteTemplate', ids)
          if (res.data.status === 1) {
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.smsTemplateList.refresh()
          }
          else {
            this.$L.alert('error', {message: '删除失败，原因:' + res.data.msg})
          }
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    addSmsTemplate () {
      this.$router.push({
        name: 'newSmsMessage',
        query: {
          status: 'new',
          id: 'newSmsMessage'
        }
      })
    },
    getDetails (item, status) {
      // console.log(item)
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'smsMessageDetail',
          query: {
            status: status,
            id: item.id
          },
        })
      }
    }
  }
}
</script>
